import { type GetSettingsPagesFamilyCustomerQuery } from "@/pages/settings/__gql__/get-family-customer.gen";
import { Flex } from "@chakra-ui/react";
import { Divider } from "@/components/essentials/divider";
import { type FC } from "react";
import { ContractSettings } from "./ContractSettings";

interface Props {
  familyCustomerContractedPlans: GetSettingsPagesFamilyCustomerQuery["familyCustomer"]["familyCustomerContractedPlans"];
}

export const ContractSettingList: FC<Props> = ({ familyCustomerContractedPlans }) => {
  return (
    <>
      {familyCustomerContractedPlans?.map(({ subscriptionInfo, contractedAt, uuid, isActive }, key) => (
        <Flex key={uuid} w="100%" flexDir="column" justifyContent="start" alignItems="start" gridGap={3}>
          {key > 0 && <Divider variant="light" w="100%" />}
          <ContractSettings
            id={uuid}
            contractName={subscriptionInfo?.name}
            contractedAt={contractedAt}
            isActive={isActive}
          />
        </Flex>
      ))}
    </>
  );
};
